import Vue from 'vue';
import VueNativeSock from 'vue-native-websocket';
import store from '../';

export default {
  state: {
    isConnected: false,
    reconnectError: false,
    serverTimeReceived: false, //
    serverTime: '1970-01-01T00:00:00.00000+00:00',
    currentDocument: {},
    transactions: [],
    flushPlannedVisits: false,
    newqrcode: { type: '' },
    newtemperature: {},
    keepalive: 0,
    edoklady: { action: '', state: '', resultState: '', data: {} },
  },
  mutations: {
    SOCKET_ONOPEN(state: any, event: any) {
      Vue.prototype.$socket = event.currentTarget;
      state.reconnectError = false;
      state.isConnected = true;
    },
    SOCKET_ONCLOSE(state: any) {
      state.isConnected = false;
      state.serverTimeReceived = false;
    },
    SOCKET_ONERROR(state: any, event: any) {
      console.error('wsERR: ', event);
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state: any, message: any) {
      console.log('SOCKET_ONMESSAGE', message.data);
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state: any, count: any) {
      console.log('SOCKET_RECONNECT', state, count);
    },
    SOCKET_RECONNECT_ERROR(state: any) {
      console.log('SOCKET_RECONNECT_ERROR', state);
      state.reconnectError = true;
    },
    keepalive(state: any) {
      clearTimeout(state.keepalive);
      state.isConnected = true;
      state.reconnectError = false;
      state.keepalive = setTimeout(() => {
        store.commit('SOCKET_ONCLOSE');
      }, 15000);
    },
    serverTime(state: any, data: any) {
      state.serverTime = data;
    },
    serverTimeReceived(state: any, data: any) {
      state.serverTimeReceived = data;
    },
    edoklady(state: any, data: any) {
      state.edoklady = data;
    },
    transactions(state: any, data: any) {
      state.transactions = data;
    },
    addTransaction(state: any, data: any) {
      state.transactions.push(data);
    },
    currentDocument(state: any, data: any) {
      state.currentDocument = data;
    },
    flushPlannedVisits(state: any, data: any) {
      state.flushPlannedVisits = data;
    },
    newqrcode(state: any, data: any) {
      state.newqrcode = data;
    },
    newtemperature(state: any, data: any) {
      state.newtemperature = data;
    },
  },
  getters: {},
  actions: {
    cleanEdokladyState(context: any) {
      context.commit('edoklady', { action: '', state: '', resultState: '', data: {} });
    },
    newqrcode(context: any, data: any) {
      context.commit('newqrcode', data.qrcode);
    },
    edoklady(context: any, data: any) {
      context.commit('edoklady', data.edoklady);
    },
    newtemperature(context: any, data: any) {
      context.commit('newtemperature', data.irtemperature);
    },
    webSocketOpen(context: any) {
      // console.log('otvaram WEBSOCKET');
      let websocketURL: string;
      websocketURL = '';
      if (window.location.protocol === 'http:') {
        websocketURL =
          'ws://' +
          window.location.hostname +
          ':' +
          window.location.port +
          `/api/v1/ws/notifications?clientID=${context.rootState.clientID}`;
      }
      if (window.location.protocol === 'https:') {
        websocketURL =
          'wss://' +
          window.location.hostname +
          ':' +
          window.location.port +
          `/api/v1/ws/notifications?clientID=${context.rootState.clientID}`;
      }
      Vue.use(VueNativeSock, websocketURL, {
        store,
        format: 'json',
        // connectManually: true,
        reconnection: process.env.NODE_ENV !== 'development', // Zablokovanie reconnect v devel mode
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
      });
      // if (!Vue.prototype.$socket) {
      //  Vue.prototype.$connect();
      // }
    },
    flushtransactions(context: any) {
      context.commit('transactions', []);
    },
    flushdocument(context: any) {
      context.commit('currentDocument', {});
    },
    flushplannedvisits(context: any) {
      context.commit('flushPlannedVisits', true);
    },
    wsHubInfo() {
      // TODO: ohandlovat a nejak vyuzit
      // console.log('HUBinfo', data);
    },
    updatetransaction(context: any, data: any) {
      // data.transaction.timeenter = moment(data.transaction.timeenter).format(context.rootState.tranDateFormat);
      if (data.transaction.timeexit === null) {
        data.transaction.timeexit = '';
      } else {
        // data.transaction.timeexit = moment(data.transaction.timeexit).format(context.rootState.tranDateFormat);
        // Inak spocitaj cas v objekte
        data.transaction.timeInObjectFormatted = '';
        if (Math.trunc(data.transaction.timeInObject / (60 * 60)) > 23) {
          data.transaction.timeInObjectFormatted = Math.trunc(data.transaction.timeInObject / (60 * 60) / 24) + '/';
          data.transaction.timeInObject =
            data.transaction.timeInObject - Math.trunc(data.transaction.timeInObject / (60 * 60) / 24) * 86400;
        }
        data.transaction.timeInObjectFormatted =
          data.transaction.timeInObjectFormatted +
          ('0' + Math.trunc(data.transaction.timeInObject / (60 * 60))).slice(-2) +
          ':' +
          ('0' + Math.trunc((data.transaction.timeInObject / 60) % 60)).slice(-2);
      }
      if (data.transaction.expire === null) {
        data.transaction.expire = '';
      }
      const tranToRemove = context.state.transactions
        .map((item: any) => {
          return item.id;
        })
        .indexOf(data.transaction.id);
      if (tranToRemove !== -1) {
        const tranEdit = [...context.state.transactions];
        tranEdit.splice(tranToRemove, 1); // remove Entry tran on Exit tran from transactions array
        context.commit('transactions', tranEdit);
      }
      data.transaction.tranFrom = 'log';
      // this.state.transactions.push(data.transaction);
      context.commit('addTransaction', data.transaction);
    },
    newdocument(context: any, data: any) {
      data.document.tranFrom = 'reader';
      context.commit('currentDocument', data.document);
    },
    time(context: any, data: any) {
      context.commit('serverTimeReceived', true);
      context.commit('serverTime', data.time.serverTime);
    },
    reload(context: any) {
      context.dispatch('getSettings');
      context.dispatch('getWorkplaceSettings');
    },
    keepalive(context: any, data: any) {
      context.commit('keepalive', data);
    },
    version(context: any, data: any) {
      if (data.version != context.rootState.version) {
        alert('Nová verze: ' + data.version + ' Potvrďte OK, případně obnovte stránku stiskem CTRL+R');
        document.location.href = '/clear';
      }
    },
  },
};
